import { useState } from 'react';
import { isValidGameUrl } from '../lib/game';

// Кнопка «Сыграть в Игру» для СВ.
// Активна, только когда прогноз на текущую неделю заполнен (маршруты + гиппера).
// Открывает игру в НОВОЙ вкладке — табель остаётся как был, поверх ничего не всплывает.

const DOW_RU = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
const MAX_ITEMS = 5;

function plural(n, one, few, many) {
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
  return many;
}
function fmtDay(iso) {
  const d = new Date(iso + 'T12:00:00');
  return `${DOW_RU[d.getDay()]} ${d.getDate()}`;
}

export default function GameBar({ settings, check, weekNo, getMrcName, onGoRoutes, onGoHyper }) {
  const [open, setOpen] = useState(false);
  if (!settings || !settings.enabled || !isValidGameUrl(settings.url)) return null;

  const ok = check.ok;
  const nR = check.routeGaps.length, nH = check.hyperGaps.length;

  const wrap = {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap',
    background: ok ? '#EAF6EE' : '#F3F5F8', border: `1px solid ${ok ? '#BFE3CB' : 'var(--border)'}`,
    borderRadius: 10, padding: '8px 10px 8px 12px', marginBottom: 12,
  };
  const btn = {
    display: 'inline-flex', alignItems: 'center', gap: 6, flex: 'none',
    border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 700,
    textDecoration: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
  };

  if (ok) {
    return (
      <div style={wrap}>
        <div style={{ fontSize: 12.5, color: '#256B3E', minWidth: 0 }}>
          🐮 Прогноз{weekNo != null ? ` на W${weekNo}` : ''} заполнен — можно отдохнуть
        </div>
        <a href={settings.url} target="_blank" rel="noopener noreferrer"
          style={{ ...btn, background: '#2FA35A', color: 'white', boxShadow: '0 2px 0 #23824A' }}>
          🎮 Сыграть в Игру
        </a>
      </div>
    );
  }

  const listStyle = { margin: '4px 0 6px', padding: 0, listStyle: 'none', fontSize: 12, lineHeight: 1.5, color: 'var(--text)' };
  const goBtn = { border: '1px solid var(--accent)', background: 'white', color: 'var(--accent)', borderRadius: 6, fontSize: 12, fontWeight: 600, padding: '4px 10px', cursor: 'pointer' };

  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ ...wrap, marginBottom: 0, borderBottomLeftRadius: open ? 0 : 10, borderBottomRightRadius: open ? 0 : 10 }}>
        <div style={{ fontSize: 12.5, color: 'var(--text-muted)', minWidth: 0 }}>
          Игра откроется, когда заполнишь прогноз{weekNo != null ? ` на W${weekNo}` : ''}
        </div>
        <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open}
          style={{ ...btn, background: '#C9CFD8', color: '#4A5565' }}>
          🔒 Сыграть в Игру
        </button>
      </div>
      {open && (
        <div style={{ border: '1px solid var(--border)', borderTop: 'none', borderRadius: '0 0 10px 10px', background: 'white', padding: '10px 12px' }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, marginBottom: 6 }}>Почему кнопка закрыта:</div>

          {nR > 0 && (
            <div style={{ marginBottom: nH ? 10 : 0 }}>
              <div style={{ fontSize: 12.5, color: 'var(--red)', fontWeight: 600 }}>
                Маршруты — нет прогноза: {check.routeDays} {plural(check.routeDays, 'день', 'дня', 'дней')} по {nR} {plural(nR, 'маршруту', 'маршрутам', 'маршрутам')}
              </div>
              <ul style={listStyle}>
                {check.routeGaps.slice(0, MAX_ITEMS).map(g => (
                  <li key={g.route.id}>• {getMrcName(g.route)} · {g.route.internal_code} — {g.dates.map(fmtDay).join(', ')}</li>
                ))}
                {nR > MAX_ITEMS && <li style={{ color: 'var(--text-muted)' }}>и ещё {nR - MAX_ITEMS} {plural(nR - MAX_ITEMS, 'маршрут', 'маршрута', 'маршрутов')}</li>}
              </ul>
              <button type="button" onClick={onGoRoutes} style={goBtn}>Открыть Табель на W{weekNo}</button>
            </div>
          )}

          {nH > 0 && (
            <div>
              <div style={{ fontSize: 12.5, color: 'var(--red)', fontWeight: 600 }}>
                Гиппера — нет планирования: {check.hyperDays} {plural(check.hyperDays, 'день', 'дня', 'дней')} по {nH} {plural(nH, 'точке', 'точкам', 'точкам')}
              </div>
              <ul style={listStyle}>
                {check.hyperGaps.slice(0, MAX_ITEMS).map(g => (
                  <li key={g.store.ship_to}>• {g.store.client || g.store.ship_to} — {g.dates.map(fmtDay).join(', ')}</li>
                ))}
                {nH > MAX_ITEMS && <li style={{ color: 'var(--text-muted)' }}>и ещё {nH - MAX_ITEMS} {plural(nH - MAX_ITEMS, 'точка', 'точки', 'точек')}</li>}
              </ul>
              <button type="button" onClick={onGoHyper} style={goBtn}>Открыть Гиппера на W{weekNo}</button>
            </div>
          )}

          <div style={{ fontSize: 11, color: 'var(--text-light)', marginTop: 8 }}>
            Считаются дни текущей недели, где есть заказ. Вакансии не учитываются.
          </div>
        </div>
      )}
    </div>
  );
}
